import { useState } from 'react';
import { useSelector } from 'react-redux';
import ClaimReportList from './СlaimReportList';
import TablePageContainer from '../../Shared/Table/widgets/TablePageContainer';
import TableTitle from '../../Shared/Table/widgets/TableTitle';

const ClaimReports = () => {
  const { en: { titles } } = useSelector((state) => state.i18n);
  const [filterStyle, setFilterStyle] = useState(false);
  const [totalCount, setTotalCount] = useState(null);

  return (
    <>
      <TablePageContainer>
        <ClaimReportList
          setTotalCount={setTotalCount}
          setFilterStyle={setFilterStyle}
          tableTitle={<TableTitle
            titleText={titles.claimReports}
            count={totalCount}
            countFiltered={filterStyle}
          />}
        />
      </TablePageContainer>
    </>
  );
};

export default ClaimReports;
